export function getNotificationDetails (notifications = [], activatedClients = []) {
  const details = {
    unreadCount: 0,
    notifications: [],
  }

  if (notifications.length === 0) {
    return details
  }

  const filteredNotifications = filterNotifications(notifications, activatedClients)

  if (!filteredNotifications || filteredNotifications.length === 0) {
    return details
  }

  const unreadCount = filteredNotifications.reduce((accumulator, notification) => {
    if (!notification.readAt) {
      accumulator = accumulator + 1
    }
    return accumulator
  }, 0)

  details.unreadCount = unreadCount
  details.notifications = filteredNotifications

  return details
}

function filterNotifications (notifications, activatedClients = []) {
  if (!notifications) {
    return []
  }

  const filteredNotifications = notifications.reduce((accumulator, notification) => {
    if (!notification.intendedClients) {
      const newNotification = Object.assign(notification, { intendedClients: activatedClients })
      accumulator.push(newNotification)
    } else {
      const qualifiedClients = notification.intendedClients.filter((clientId) => {
        if (clientId.toUpperCase() === 'SHGN') {
          return true
        }
        return activatedClients.indexOf(clientId) > -1
      })

      if (qualifiedClients.length > 0) {
        accumulator.push(notification)
      }
    }

    return accumulator
  }, [])
  return filteredNotifications
}



// WEBPACK FOOTER //
// ./src/tools/notifications/index.js